import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledButton = styled(Button)`
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.noodle.primary};
  border: 1px solid ${({ theme }) => theme.palette.noodle.primary};
  ${({ theme }) => theme.noodera.fontTypes.font5};
`;

export const Title = styled.h1`
  ${({ theme }) => theme.noodera.fontTypes.font3Medium};
  margin-top: 0;
`;

export const Subtitle = styled.h2`
  ${({ theme }) => theme.noodera.fontTypes.font4};
`;
